import React from 'react';
import styled from 'styled-components/macro';

const FormWrapNoStyle = ({
  children,
  ...otherProps
}) => (
  <div {...otherProps}>
    {children}
  </div>
);
export default styled(FormWrapNoStyle)`
  background: ${({ theme }) => theme.colors.colorGreyLight};
  border-top: 0px solid ${({ theme }) => theme.colors.colorBlue};
  padding: 15px;
`;
